<template>
  <div class="job-detail-state-container">
    <div>
      <div class="job-detail-state-progress">
        <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('quan-liang-qian-yi-0') }}
          <a @click="handleShowLog(task.dataTaskId)">{{ $t('cha-kan-ri-zhi') }}</a>
        </p>
        <div class="job-detail-state-count">
          <div class="circle-background"></div>
          <i-circle :stroke-width="5" :stroke-color="getCurrentStateColor('FULL')"
                    :percent="fullProgress.transPercent" :size="200">
            <span class="detail-Circle-inner"
                  style="font-size:50px">{{ fullProgress.transPercent }}%</span>
          </i-circle>
          <p style="margin-top: 32px">{{ $t('yi-qian-yi') }}<span
            style="font-weight: 600">{{ $i18n.locale==='en-US'?formatEnCount(fullProgress.trans):formatCount(fullProgress.trans) }}</span>{{ $t('hang') }}</p>
        </div>
      </div>
      <div class="job-detail-state-detail">
        <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('ge-ku-biao-qian-yi-jin-du') }}</p>
        <div class="table-filter">
          <CheckboxGroup v-model="theFilterJobStatus" style="display: inline-block"
                         @on-change="handleFilterFullTable(theFilterJobStatus,theFilterTableName)">
            <Checkbox label="running">{{ $t('qian-yi-zhong') }}</Checkbox>
            <Checkbox label="wait">{{ $t('dai-qian-yi') }}</Checkbox>
            <Checkbox label="finish">{{ $t('qian-yi-wan-cheng') }}</Checkbox>
          </CheckboxGroup>
          <Input prefix="ios-search" v-model="theFilterTableName" :placeholder="$t('qing-shu-ru-biao-ming-shai-xuan')"
                 style="width: 150px"
                 @on-change="handleFilterFullTable(theFilterJobStatus,theFilterTableName)"/>
        </div>
        <Table stripe style="margin-top: 20px" :border="false" size="small"
               :columns="fullTransColumns" :data="showFullTransData" max-height="300">
          <template slot-scope="{ row }" slot="progress">
            <div>
              <Progress :percent="row.transPercent" :stroke-width="10"
                        :stroke-color="getProgressStatus(taskList['FULL'].dataTaskStatus)==='normal'?['#ff9900', '#ff9900']:''"
                        :status="getProgressStatus(taskList['FULL'].dataTaskStatus)">
                <span style="font-weight: 500">{{ row.transPercent }}%</span>
              </Progress>
            </div>
          </template>
        </Table>
        <Page style="margin-top:20px;text-align: center" :total="fullTotal" size="small" :current.sync="fullPage"
              show-elevator :page-size="fullSize"
              @on-change="handleFullPageChange"/>
      </div>
    </div>
    <div class="job-detail-metric">
      <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('qian-yi-su-shuai') }}
        <a @click="handleMoreMonitor(taskList['FULL'].dataTaskId,'FULL')">{{ $t('geng-duo-zhi-biao') }}</a></p>
      <div style="margin-top:20px">
        <div class="panel">
          <div class="panel-header">
            <div style="float: right">
            </div>

            {{ metric.title }}
          </div>
          <div class="panel-body">
            <div style="height: 200px">
              <Metric ref="metric1" :model="metric" :time="time" :resourceType="resourceType"
                      :dataJobId="jobId.toString()"
                      :filters="filters" :selected="metric.selected"
                      :dataTaskId="taskList['FULL'].dataTaskId.toString()"
                      :filterOthers="filterOthers"></Metric>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { formatCount, formatEnCount } from '../../../util';
import Metric from '../../monitor/metric/metric';

export default {
  components: { Metric },
  props: {
    getCurrentStateColor: Function,
    fullProgress: Object,
    handleFilterFullTable: Function,
    showFullTransData: Array,
    getProgressStatus: Function,
    taskList: Object,
    fullPage: Number,
    fullTotal: Number,
    fullSize: Number,
    handleFullPageChange: Function,
    handleMoreMonitor: Function,
    resourceType: String,
    filters: Object,
    filterOthers: Object,
    metric: Object,
    time: Object,
    jobId: Number,
    filterJobStatus: Array,
    filterTableName: String,
    handleShowLog: Function,
    task: Object
  },
  data() {
    return {
      theFilterJobStatus: this.filterJobStatus,
      theFilterTableName: this.filterTableName,
      formatCount,
      formatEnCount,
      fullTransColumns: [
        {
          title: this.$t('shu-ju-ku'),
          key: 'schema',
          minWidth: 150
        },
        {
          title: this.$t('biao-ming'),
          key: 'table',
          minWidth: 220
        },
        {
          title: ' ',
          slot: 'progress',
          width: 160
        },
        {
          title: ' ',
          slot: 'progress',
          width: 200,
          render: (h, params) => h('div', {}, this.$t('yi-qian-yi-formatcountparamsrowtrans-hang', [this.$i18n.locale === 'en-US' ? formatEnCount(params.row.trans) : formatCount(params.row.trans)]))
        }
      ]
    };
  },
  methods: {
    handleRender() {
      const that = this;

      setTimeout(() => {
        if (that.$refs.metric1) {
          that.$refs.metric1.$emit('render');
        } else {
          _.forEach(that.$refs.metrics, (m) => {
            m.$emit('render');
          });
        }
        if (that.$refs.metric2) {
          that.$refs.metric2.$emit('render');
        }
      }, 100);
    }
  },
  watch: {
    filterJobStatus(val) {
      this.theFilterJobStatus = val;
    },
    filterTableName(val) {
      this.theFilterTableName = val;
    }
  }
};
</script>
